import axios from "axios";
import { getCookie } from "./cookies";
import { apiUrl } from "../config";

interface ApiRequestOptions {
  endpoint: string;
  method: string;
  payload?: any;
  noAuth?: boolean;
}

export const apiRequest = async ({
  endpoint,
  method,
  payload,
  noAuth,
}: ApiRequestOptions): Promise<any> => {
  const token = getCookie() || "";
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (!noAuth) {
    headers.Authorization = token;
  }
  // Lazy import to avoid circular dependency with app store
  try {
    const { useAppStore } = await import("modules/app/store");
    const orgUuid = useAppStore.getState().selectedOrganizationUuid;
    if (orgUuid) headers.organizationUuid = orgUuid;
  } catch {
    // app store not yet available
  }
  const response = await axios({
    method,
    url: apiUrl + endpoint,
    data: payload,
    headers,
  });
  return response.data;
};
